<template>
    <div class="reviews clearfix">
        <div class="wrapper">
            <div class="col-xs-120 no-padding">
                <router-link to="#" name="otzivy"></router-link>
                <h2>Истории ремонта автомобиля</h2>
                <div class="block slider-responsive clearfix">
                    <div class="col-sm-40" :key="review.id" v-for="review in reviews">
                        <div class="comment">
                            <div class="name">{{review.name}}</div>
                            <div class="stars">
                                <span class="count">{{review.star}}</span>
                                <input class="stars star-4" :checked="review.star === 5" readonly type="radio" :name="'reviewStars['+review.id+']'"/><label title="gorgeous"></label>
                                <input class="stars star-3" :checked="review.star === 4" readonly type="radio" :name="'reviewStars['+review.id+']'"/><label title="good"></label>
                                <input class="stars star-2" :checked="review.star === 3" readonly type="radio" :name="'reviewStars['+review.id+']'"/><label title="regular"></label>
                                <input class="stars star-1" :checked="review.star === 2" readonly type="radio" :name="'reviewStars['+review.id+']'"/><label title="poor"></label>
                                <input class="stars star-0" :checked="review.star === 1" readonly type="radio" :name="'reviewStars['+review.id+']'"/><label title="bad"></label>
                            </div>
                            <div class="date">{{review.date}}</div>
                            <div class="text">
                                <p class="text-title">{{review.job}}</p>
                                {{review.text}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'slick-carousel'
export default {
  name: 'Reviews',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      reviews: []
    }
  },
  created () {
  },
  methods: {
  },
  mounted () {
    axios.get('https://crm.v-avtoservice.com/list/site-reviews').then(response => {
      this.reviews = response.data
      setTimeout(function () {
        $('.slider-responsive').slick({
          dots: false,
          infinite: true,
          speed: 2000,
          autoplay: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          rows: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        })
      }, 300)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/blocks/Reviews.vue